exports.baseURL = "https://appadmin.vibelynk.com/";

exports.key = "OofTOfK5wrHUpdMcbnzDSd1D3zDH3KkE";
